export const REORDER_AREA_ENTRY_STRATEGY = 'REORDER_AREA_ENTRY_STRATEGY';
export const REORDER_AREA_ENTRY_STRATEGY_SUCCESSFUL = 'REORDER_AREA_ENTRY_STRATEGY_SUCCESSFUL';
export const REORDER_AREA_ENTRY_STRATEGY_FAILED = 'REORDER_AREA_ENTRY_STRATEGY_FAILED';
